// On/off switch used across product-card sections (featured collections,
// the main collection grid, related products): flips whether cards show
// their first or second image by default. State lives only in the DOM
// (aria-checked + a class on the section's product wrapper) — nothing is
// persisted, so a refresh always comes back to "off".
//
// On mobile there is no tap-to-preview while a toggle is on — the card
// just shows the second image, full stop, and tapping it navigates
// normally like any other product card. (Whatever preview-on-tap effect
// you see with the toggle *off* is the site's separate, pre-existing
// default card behavior — untouched by this file either way.)
if (!window.__collectionImageToggleBound) {
  window.__collectionImageToggleBound = true;

  function resetAllToggles() {
    document.querySelectorAll('.collection-image-toggle[aria-checked="true"]').forEach(function (toggle) {
      toggle.setAttribute('aria-checked', 'false');
      var target = document.getElementById(toggle.getAttribute('data-collection-target'));
      if (target) target.classList.remove('image-toggle-on');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.collection-image-toggle');
    if (!toggle) return;

    var isOn = toggle.getAttribute('aria-checked') === 'true';
    var next = !isOn;
    toggle.setAttribute('aria-checked', String(next));

    var target = document.getElementById(toggle.getAttribute('data-collection-target'));
    if (target) {
      target.classList.toggle('image-toggle-on', next);
    }
  });

  // Some mobile browsers (notably iOS Safari) restore a page from their
  // back/forward cache exactly as it was left — including this script's
  // DOM changes — instead of doing a fresh load, so a plain page-load
  // reset never runs. Catch that case explicitly.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resetAllToggles();
    }
  });
}
